import Link from "next/link";
import { FC } from "react";

import { usePublicSettings } from "@/contexts/public_settings_context";
import cn from "@/utils/core/cn";

const NavbarLogo: FC<{ className?: string }> = ({ className }) => {
  const { PUBLIC_MINIMAL_UI } = usePublicSettings();

  if (PUBLIC_MINIMAL_UI) {
    return null;
  }

  return (
    <Link
      href="/questions/"
      className={cn(
        "inline-flex flex-shrink-0 flex-grow-0 basis-auto flex-col justify-center px-4 text-center no-underline",
        className
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="28"
        viewBox="0 0 34 28"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.424 0.347912C20.7455 -0.399847 19.5966 0.137405 19.5966 1.20245V9.27503L11.4964 0.347912C10.8179 -0.399847 9.66902 0.137406 9.66902 1.20245V9.18738L1.83436 0.393044C1.15868 -0.3654 0 0.169468 0 1.23982V14.3672C0 14.6987 0.12266 15.0154 0.338895 15.2423L12.1551 27.6382C12.8407 28.3574 13.9635 27.814 13.9635 26.7632V19.31L22.0899 27.6801C22.7779 28.3887 23.8911 27.8432 23.8911 26.7976V19.31L32.0175 27.6801C32.7055 28.3887 33.8187 27.8432 33.8187 26.7976V14.5099C33.8187 14.1887 33.7035 13.8809 33.4988 13.6554L21.424 0.347912Z"
          fill="currentColor"
        />
      </svg>
    </Link>
  );
};

export default NavbarLogo;
